import { useState } from "react";
import "./form.css";
import { Col, Form, Row } from "react-bootstrap";
import Button from "@/components/common/buttons/Button";
import facebookIcon from "@/assets/facebook.png";
import instagramIcon from "@/assets/instagram.png";
import whatsappIcon from "@/assets/whatsapp.png";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const requiredFields = [
      { field: 'name', label: 'Nume Prenume' },
      { field: 'email', label: 'Adresa de email' },
      { field: 'message', label: 'Mesajul tau' }
    ];

    const missingFields = requiredFields.filter(item => !formData[item.field as keyof typeof formData]);
    
    if (missingFields.length > 0) {
      const fieldNames = missingFields.map(item => item.label).join(', ');
      alert(`Te rugăm completează următoarele câmpuri: ${fieldNames}`);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    // Only call preventDefault if we have a real form event
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch('https://pixado.ro/api/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      const result = await response.json();
      
      if (result.success) {
        alert('Cererea a fost trimisă cu succes! Vei primi un răspuns în maxim 48 de ore.');
        setFormData({
          name: '', email: '', phone: '', service: '', message: ''
        });
      } else {
        alert('A apărut o eroare. Te rugăm încearcă din nou.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('A apărut o eroare. Te rugăm încearcă din nou.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Form className="contact-form" onSubmit={handleSubmit}>
        <Row className="contact-row">
          <Col xs={12} lg={6}>
            <Form.Group className="input-wrapper-left">
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="body contact-input"
                placeholder="Nume Prenume *"
                required
              />
            </Form.Group>
          </Col>
          <Col xs={12} lg={6}>
            <Form.Group className="input-wrapper-right">
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="body contact-input"
                placeholder="Adresa de email *"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="contact-row">
          <Col xs={12} lg={6}>
            <Form.Group className="input-wrapper-left">
              <Form.Control
                type="number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="body contact-input"
                placeholder="Numar de telefon"
              />
            </Form.Group>
          </Col>
          <Col xs={12} lg={6}>
            <Form.Group className="input-wrapper-right">
              <Form.Control
                type="text"
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="body contact-input"
                placeholder="Serviciul"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="contact-row">
          <Col xs={12}>
            <Form.Group>
              <Form.Control
                as="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="contact-textarea body contact-input"
                placeholder="Mesajul tau *"
                required
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
      <Row className="contact-submit-row">
        <Col xs={12} lg={6}>
          <Row className="body">
            Prin trimiterea mesajului, ești de acord cu Politica de Confidențialitate
          </Row>
          <Button 
            className="contact-button" 
            text={isSubmitting ? "Se trimite..." : "Trimite cererea"}
            onClick={() => handleSubmit()}
          />
        </Col>
        <Col className="submit-second-col" xs={12} lg={{ span: 4, offset: 2 }}>
          <Row className="body">Hai cu noi pe social media!</Row>
          <Row>
            <Col xs={4}>
              <a href="https://www.facebook.com/pixadoagency" target="_blank" rel="noopener noreferrer">
                <img src={facebookIcon} className="contact-dot" alt="Facebook" />
              </a>
            </Col>
            <Col xs={4}>
              <a href="https://www.instagram.com/pixadoagency/" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} className="contact-dot" alt="Instagram" />
              </a>
            </Col>
            <Col xs={4}>
              <a href="https://wa.me/40745371620" target="_blank" rel="noopener noreferrer">
                <img src={whatsappIcon} className="contact-dot" alt="WhatsApp" />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ContactForm;